<header id="header">
    <nav class="row">
        <a class="column" href="/">
            <span class="logo"><img alt="Markizano.NET" src="//markizano.net/assets/images/logo.png" /></span>
            <span> Markizano.NET </span>
        </a>
        <a target="_blank" class="column" href="https://blog.markizano.net/">
            <span><img alt="Blog" src="//markizano.net/assets/images/blogger.ico" /></span>
            <span>Blog</span>
        </a>
        <a target="_blank" class="column" href="https://github.com/markizano">
            <span><img alt="Github" src="//markizano.net/assets/images/github.ico" /></span>
            <span>Github</span>
        </a>
        <a target="_blank" class="column" href="https://youtube.com/@KizanosFinTech">
            <span><img alt="YouTube" src="//markizano.net/assets/images/youtube.ico" /></span>
            <span>YouTube</span>
        </a>
        <a target="_blank" class="column" href="https://www.tiktok.com/@Kizanos.FinTech">
            <span><img alt="TikTok" src="//markizano.net/assets/images/tiktok.ico" /></span>
            <span>TikTok</span>
        </a>
        <a target="_blank" class="column" href="//markizano.net/chat">
            <span><img alt="Discord" src="//markizano.net/assets/images/discord.ico" /></span>
            <span>Discord</span>
        </a>
</nav>
</header>
<router-outlet></router-outlet>
<footer id="footer">
    Copyright <script type="text/javascript">
        document.write((new Date()).getFullYear())
    </script> Markizano.NET, LLC.<br />&nbsp;
    <em>Powered by HTML!</em><br />
    <p>My Public Encryption Key: <a href="https://markizano.net/enc.asc">3F174174FCCCCA69AD0D7C3463C7EAC6B3BF88B1</a></p>
    <p>My Public Signatures Key: <a href="https://markizano.net/key.asc">C5EAC623531280A9A4067E705419010671E96AA3</a></p>
    <p><a href="#/tos" [routerLink]="['/tos']" routerLinkActive="router-link-active" >Terms of Service</a></p>
    <p><a href="#/policy" [routerLink]="['/privacy']">Privacy Policy</a></p>
</footer>
<br />&nbsp;<br />&nbsp;
